import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "../api";

export default function Appointments() {
  const qc = useQueryClient();
  const { data: liste = [], isLoading } = useQuery({ queryKey: ["admin-appts"], queryFn: async () => (await api.get("/admin/appointments")).data });
  const upd = async (id, body) => { await api.put(`/admin/appointments/${id}`, body); qc.invalidateQueries({ queryKey: ["admin-appts"] }); toast.success("Güncellendi"); };
  if (isLoading) return <p className="veri">Yükleniyor…</p>;
  return (
    <div>
      <h1 style={{ fontFamily: "var(--display)", fontSize: 26, marginBottom: 16 }}>Randevu</h1>
      {liste.length === 0 ? <div className="a-bos">Henüz randevu yok.</div> : (
        <table className="a-tablo">
          <thead><tr><th>Tarih</th><th>Saat</th><th>Proje</th><th>Ad</th><th>Telefon</th><th>Danışman</th><th>Durum</th><th></th></tr></thead>
          <tbody>
            {liste.map((a) => (
              <tr key={a.id} data-testid={`appt-${a.id}`}>
                <td className="sayi">{a.tarih}</td><td className="sayi">{a.saat}</td><td>{a.proje}</td><td>{a.ad}</td><td className="sayi">{a.telefon}</td>
                <td><input defaultValue={a.danisman} onBlur={(e) => upd(a.id, { danisman: e.target.value })} placeholder="Ata…" /></td>
                <td>{a.durum}</td>
                <td className="a-satir">
                  <button className="a-btn hayalet kucuk" onClick={() => upd(a.id, { durum: "onaylandi" })}>Onay</button>
                  <button className="a-btn hayalet kucuk" onClick={() => upd(a.id, { durum: "iptal" })} data-testid={`appt-iptal-${a.id}`}>İptal</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
